// API 端点配置
export const API_ENDPOINTS = {
  USER: {
    PROFILE_SHARE_QUERY: '/kiti-user/api/anon/user/profile/share/query'
  },
  // 埋点上报相关
  REPORT: {
    H5_REPORT: 'kiti-report/app/reportH5'
  }
} as const

// 环境配置
export const ENV_CONFIG = {
  // 埋点上报 API 地址
  REPORT_API: import.meta.env.VITE_REPORT_API,
  // 通用 API 地址
  BASE_API: import.meta.env.VITE_BASE_API,
  // 是否为生产环境
  IS_PROD: import.meta.env.PROD
} as const
